import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import ModalContainer from 'v-c/Modals/ModalContainer';
import ModalHeader from 'v-c/Modals/ModalHeader';
import ModalButtons from 'v-c/Modals/ModalButtons';
import ModalContentLeft from 'v-c/Modals/ModalContentLeft';
import ModalText from 'v-c/Modals/ModalText';
import { StackedCheckboxContainer, LargeCheckbox } from 'v-c/Forms/Checkboxes';
import { FormattedMessage, FormattedHTMLMessage } from 'component-utilities/intl';

export default function EditReport(props) {
    const {
        type,
        doNotShowAgainFor,
        modal: { doNotShowAgain },
        toggleDoNotShowAgain,
        close,
        onPrimaryButtonClick,
        onSecondaryButtonClick,
    } = props;

    const BASE_KEY = 'components.modals.edit_report';
    const TYPE_KEY = `${BASE_KEY}.${doNotShowAgainFor}`;
    const showAgainChecked = doNotShowAgainFor === type;

    return (
        <ModalContainer>
            <ModalHeader type={`report-${type}`} onCloseClick={close}>
                <FormattedMessage id={`${TYPE_KEY}.header`} />
            </ModalHeader>
            <ModalContentLeft>
                <FormattedHTMLMessage id={`${TYPE_KEY}.content`} />
                {showAgainChecked && (
                    <StackedCheckboxContainer>
                        <LargeCheckbox
                            data-input="do-not-show-again"
                            checked={doNotShowAgain}
                            onClick={toggleDoNotShowAgain}
                            rawChildren
                        >
                            <ModalText checkbox>
                                <FormattedMessage id={`${BASE_KEY}.do_not_show_checkbox`} />
                            </ModalText>
                        </LargeCheckbox>
                    </StackedCheckboxContainer>
                )}
            </ModalContentLeft>

            <ModalButtons
                primaryText={<FormattedMessage id={`${BASE_KEY}.primary_button`} />}
                onPrimaryClick={onPrimaryButtonClick}
                onSecondaryClick={onSecondaryButtonClick}
                secondaryText={<FormattedMessage id={`${BASE_KEY}.secondary_button`} />}
            />
        </ModalContainer>
    );
}

EditReport.displayName = displayName('Modals/EditReport');

EditReport.propTypes = {
    modal: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    doNotShowAgainFor: PropTypes.string.isRequired,
    toggleDoNotShowAgain: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    onPrimaryButtonClick: PropTypes.func.isRequired,
    onSecondaryButtonClick: PropTypes.func.isRequired,
};
